import React, { Fragment } from 'react';

import NavbarDefault from './NavbarDefault';
import Navbar from './Navbar';

const Header = () => {
   return (
      <Fragment>
         <NavbarDefault />
         <Navbar />
      </Fragment>
   )
};

export default Header;